import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import OptionGroup from '../../../smoothr-web-app-core/models/OptionGroup';
import ArticleOption from '../../../smoothr-web-app-core/models/ArticleOption';
import { DisplayIdentifier } from '../../../smoothr-web-app-core/enums/DisplayIdentifier';
import Article from '../../../smoothr-web-app-core/models/Article';
import { PreorderType } from '../../../smoothr-web-app-core/enums/PreorderType';
import { OrderType } from '../../../smoothr-web-app-core/enums/OrderType';
import { getAvailability, getPrice, numberToCurrency } from '../../../smoothr-web-app-core/utils/utils';
import { AppComponent } from 'src/app/app.component';
import ArticleGroup from 'src/smoothr-web-app-core/models/ArticleGroup';

@Component({
	selector: 'app-article-option-group-custom',
	templateUrl: './article-option-group-custom.component.html',
	styleUrls: ['article-option-group-custom.component.scss'],
	standalone: false,
})
export class ArticleOptionGroupCustomComponent implements OnInit, AfterViewInit {
	optionGroupValue: OptionGroup;
	@Input() isVertical: boolean = false;
	@ViewChild('wrapperArticles') wrapperArticles: ElementRef<HTMLElement>;
	@Input() article: Article;
	@Output() selection = new EventEmitter<ArticleOption>();
	@Input() preorderType: PreorderType;
	@Input() currency: string;
	@Input() customView: boolean = false;
	@Input() showAllButton = true;
	@Input() filtersValues: string[] = [];
	@Input() articleGroup: ArticleGroup;
	@Output() openInfo = new EventEmitter<Article>();
	di = DisplayIdentifier;
	showFirstArticles = false;
	showBackIcon = false;
	showNextIcon = false;
	numberToCurrency = numberToCurrency;

	constructor() {}

	@Input() set optionGroup(value: OptionGroup) {
		if (value) {
			value.articles = value.articles.filter(it => !this.isHidden(it) && !it.hidden);
			this.optionGroupValue = value;
		}
	}

	private _selected: ArticleOption[] = [];

	get selected(): ArticleOption[] {
		return this._selected;
	}

	@Input()
	set selected(value: ArticleOption[]) {
		this._selected = value;
	}

	ngOnInit() {}

	ngAfterViewInit() {
		setTimeout(() => {
			this.updateScrollIcons();
		}, 1000);
	}

	ionViewDidEnter() {
		this.updateScrollIcons();
	}

	onAdd(article: Article) {
		if (!article) return;

		// Check if we've reached the group limit
		if (this.articleGroup && this.optionGroupValue.limit > 0) {
			const foundOptions = this.articleGroup.groups.filter(it => it.group === this.optionGroupValue._id);
			const currentTotal = foundOptions.reduce((a, b) => a + b.quantity, 0);

			if (currentTotal >= this.optionGroupValue.limit && this.optionGroupValue.limit !== 1) {
				console.log('Limit reached for group:', this.optionGroupValue.limit);
				return;
			}
		}

		console.log('ON ADD', article.name);
		const articleOption = new ArticleOption();
		articleOption.article = article;
		articleOption.group = this.optionGroupValue._id;
		articleOption.quantity = 1;
		this.selection.emit(articleOption);
	}

	onRemove(article: Article) {
		if (!article) return;

		const currentCount = this.count(article);
		if (currentCount <= 0) {
			console.log('Cannot remove, count is 0');
			return;
		}

		console.log('ON REMOVE', article.name);
		const option = new ArticleOption();
		option.article = article;
		option.quantity = -1;
		option.group = this.optionGroupValue._id;
		this.selection.emit(option);
	}

	count(article: Article): number {
		if (!this.selected || !article) return 0;
		return this.selected
			.filter(ao => ao.article._id === article._id && ao.group === this.optionGroupValue._id)
			.reduce((prev, curr) => prev + curr.quantity, 0);
	}

	isHidden(article: Article): boolean {
		return !getAvailability(article, OrderType.STANDARD, this.preorderType);
	}

	findArticleBrot(optionGroup: OptionGroup) {
		return optionGroup.articles.find(it => it.visible);
	}

	showAll(value: boolean) {
		this.showFirstArticles = value;
	}

	checkIfModifierSelectExist(optionGroup: OptionGroup) {
		return !!(optionGroup?.tags ?? []).find(it => it?.identifier === 'modifier_select');
	}

	checkIfModifierRemoveExist(optionGroup: OptionGroup) {
		return !!(optionGroup?.tags ?? []).find(it => it?.identifier === 'modifier_remove');
	}

	scrollBack() {
		const wrapper = this.wrapperArticles.nativeElement;
		wrapper.scrollBy({
			top: 0,
			left: -wrapper.clientWidth,
			behavior: 'smooth',
		});
	}

	scrollForward() {
		const wrapper = this.wrapperArticles.nativeElement;
		wrapper.scrollBy({
			top: 0,
			left: wrapper.clientWidth,
			behavior: 'smooth',
		});
	}

	onScroll() {
		this.updateScrollIcons();
	}

	updateScrollIcons() {
		// if (this.showAmount && this.optionGroupValue?.articles && this.optionGroupValue?.articles?.length <= 3) {
		// 	this.showBackIcon = false;
		// 	this.showNextIcon = false;
		// 	return;
		// }
		// const wrapper = this.wrapperArticles.nativeElement;
		// const maxScrollLeft = wrapper.scrollWidth - wrapper.clientWidth;
		// this.showBackIcon = wrapper.scrollLeft > 0;
		// this.showNextIcon = wrapper.scrollLeft < maxScrollLeft;
	}

	ifFilterVisible(article: Article) {
		if (this.filtersValues.length === 0) {
			return false;
		}
		let articleFilter = false;
		this.filtersValues.forEach(it => {
			if (it == 'meat') {
				if (
					article?.compound?.features &&
					(article.compound.features['beef'] === true ||
						article.compound.features['chicken'] === true ||
						article.compound.features['pork'] === true)
				) {
					articleFilter = true;
				}
			}
			if (article?.compound?.features && article.compound.features[it] && article.compound.features[it] == true) {
				articleFilter = true;
			}
			if (article?.compound?.allergens && it === 'gluten' && article.compound.allergens['cerealsContainingGluten'] == true) {
				articleFilter = true;
			}
			if (article?.compound?.allergens && it === 'peanut' && article.compound.allergens['peanutsAndProductsThereof'] == true) {
				articleFilter = true;
			}
			if (article?.compound?.allergens && it === 'lactose' && article.compound.allergens['milkAndProductsThereof'] == true) {
				articleFilter = true;
			}
		});
		return articleFilter;
	}

	openInfoEmit(article: Article) {
		this.openInfo.emit(article);
	}

	getArticlePrice(article: Article): number {
		if (!article) return 0;

		if (this.optionGroupValue?.tags?.find(it => it?.identifier == 'noprice')) {
			return 0;
		}

		if (article?.displayPriceByType?.preorder) {
			const price =
				article.displayPriceByType.preorder.takeAway ||
				article.displayPriceByType.preorder.inside ||
				article.displayPriceByType.preorder.delivery;
			if (price && price.$numberDecimal !== undefined && price.$numberDecimal === 0) {
				return 0;
			}
		}

		return getPrice(article, OrderType.STANDARD, this.preorderType);
	}
}
